import React from 'react';
import { connect as formikConnect, getIn } from 'formik';
import { TextFieldProps } from '@mui/material';
import TextField, { Props } from './index';

export const withFormikTextFieldWrapper = (WrappedComponent: React.ComponentType<Props>) => formikConnect<Props>(({ formik, ...props }) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { target: { value } } = event;
    if (props.onChange) {
      props.onChange(event);
    } else {
      formik.setFieldValue(props.name, value);
    }
  };

  const handleBlur = (event: any) => {
    if (props.onBlur) {
      props.onBlur(event);
    } else {
      formik.setFieldTouched(props.name);
    }
  };

  const handleClear = (defaultValue: TextFieldProps['value']) => {
    if (props.onClear) props.onClear(defaultValue);
    else formik.setFieldValue(props.name, defaultValue === null ? null : defaultValue || '');
  };

  const error: any = getIn(formik.errors, props.name);
  const touched: boolean = getIn(formik.touched, props.name);
  const value: string | null | undefined = getIn(formik.values, props.name);
  const showErr = !!(error && touched);

  return (
    <WrappedComponent
      {...props}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onClear={handleClear}
      error={showErr}
      helperText={showErr ? error : props.helperText}
    />
  );
});

export default withFormikTextFieldWrapper(TextField);
